export const getCert = () => {
	return (
		'-----BEGIN CERTIFICATE-----\n' +
		'MIIFVTCCBD2gAwIBAgIMdbnFBbHWNvz8+pgrMA0GCSqGSIb3DQEBCwUAMGYxCzAJ\n' +
		'BgNVBAYTAkJFMRkwFwYDVQQKExBHbG9iYWxTaWduIG52LXNhMTwwOgYDVQQDEzNH\n' +
		'bG9iYWxTaWduIE9yZ2FuaXphdGlvbiBWYWxpZGF0aW9uIENBIC0gU0hBMjU2IC0g\n' +
		'RzIwHhcNMTcwMzE0MTM1MDQ0WhcNMjAwMzE0MTM1MDQ0WjB6MQswCQYDVQQGEwJD\n' +
		'SDETMBEGA1UECBMKV2ludGVydGh1cjEPMA0GA1UEBxMGWnVyaWNoMR4wHAYDVQQK\n' +
		'ExVDaW1wcmVzcyBTY2h3ZWl6IEdtYkgxJTAjBgNVBAMTHGNvbnNvbGUuc2hpcHBp\n' +
		'bmcuY2ltcHJlc3MuaW8wggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQCD\n' +
		'VEqCv23qLe9xOz31UcVUlMHOKx4deT75G5CX5XdmdQDUPDme1XblmC/YWONcBoVH\n' +
		'XSSyYCW+4NXgN2UtPI6be7Ws/DaebTQ0I9I5hNWWIby7dwIrw5jeLDjKQLW9v/CT\n' +
		'yTQQbi9NQQhRw3evh3hSDz9foX/E4YnaQ15wdHZaOgdmZ2K8bGQYD3Y0X/G+P9WO\n' +
		'IbpdogL6+IRwrT3V/+AUMOqdks7crBQDACdMLovBsi2gThfi4y3Yqj3xG18RODoO\n' +
		'2bhIsZ6mhlrqC3odIBR/ew/8N0uhX0P9ywoTg8C79kPRBFhig43BRsxZWtuS05mU\n' +
		'0OqHIDEezb3a6m+q3XoHAgMBAAGjggHtMIIB6TAOBgNVHQ8BAf8EBAMCBaAwgaAG\n' +
		'CCsGAQUFBwEBBIGTMIGQME0GCCsGAQUFBzAChkFodHRwOi8vc2VjdXJlLmdsb2Jh\n' +
		'bHNpZ24uY29tL2NhY2VydC9nc29yZ2FuaXphdGlvbnZhbHNoYTJnMnIxLmNydDA/\n' +
		'BggrBgEFBQcwAYYzaHR0cDovL29jc3AyLmdsb2JhbHNpZ24uY29tL2dzb3JnYW5p\n' +
		'emF0aW9udmFsc2hhMmcyMFYGA1UdIARPME0wQQYJKwYBBAGgMgEUMDQwMgYIKwYB\n' +
		'BQUHAgEWJmh0dHBzOi8vd3d3Lmdsb2JhbHNpZ24uY29tL3JlcG9zaXRvcnkvMAgG\n' +
		'BmeBDAECAjAJBgNVHRMEAjAAMEkGA1UdHwRCMEAwPqA8oDqGOGh0dHA6Ly9jcmwu\n' +
		'Z2xvYmFsc2lnbi5jb20vZ3MvZ3Nvcmdhbml6YXRpb252YWxzaGEyZzIuY3JsMCcG\n' +
		'A1UdEQQgMB6CHGNvbnNvbGUuc2hpcHBpbmcuY2ltcHJlc3MuaW8wHQYDVR0lBBYw\n' +
		'FAYIKwYBBQUHAwEGCCsGAQUFBwMCMB0GA1UdDgQWBBS4SzKUvm56rJDH1FAgM/Wy\n' +
		'oiP6vTAfBgNVHSMEGDAWgBSW3mHxvRwWKVMcwMx9O4MAQOYafDANBgkqhkiG9w0B\n' +
		'AQsFAAOCAQEAxCGsB1wXNo2uhCVxXIzt74+krAhNwFjHCREBESb2YjWyzb2vZ58B\n' +
		'zFUlZsUJ6yps+yt+3swQ5x34OgCxb0vQA+Zz9eEh+X/dT/jzF26YRpRu4mVWHBsP\n' +
		'Wbt4ulPYc5ae36MH5LPR8qI9kYv6KkvcY60FK9S1vJjmJHqqUWSwgtVcS5fra+qN\n' +
		'fHPc75cxdfktLgL221Y75ADQZ/XWlnoaEqfWTXd6E+Kcsd20AOwYjV6atIUTRgKl\n' +
		'Nxq/BflRo6R4Jh42oeUmwTvIXPvc1BsWnOtlwBVf/KNg3/HBP/JXGxdOuPJ4s+p4\n' +
		'J/Dad5zFlo4UmPvUk/fCm6pCXCh9A2AYsw==\n' +
		'-----END CERTIFICATE-----\n' +
		'--START INTERMEDIATE CERT--\n' +
		'-----BEGIN CERTIFICATE-----\n' +
		'MIIEaTCCA1GgAwIBAgILBAAAAAABRE7wQkcwDQYJKoZIhvcNAQELBQAwVzELMAkG\n' +
		'A1UEBhMCQkUxGTAXBgNVBAoTEEdsb2JhbFNpZ24gbnYtc2ExEDAOBgNVBAsTB1Jv\n' +
		'b3QgQ0ExGzAZBgNVBAMTEkdsb2JhbFNpZ24gUm9vdCBDQTAeFw0xNDAyMjAxMDAw\n' +
		'MDBaFw0yNDAyMjAxMDAwMDBaMGYxCzAJBgNVBAYTAkJFMRkwFwYDVQQKExBHbG9i\n' +
		'YWxTaWduIG52LXNhMTwwOgYDVQQDEzNHbG9iYWxTaWduIE9yZ2FuaXphdGlvbiBW\n' +
		'YWxpZGF0aW9uIENBIC0gU0hBMjU2IC0gRzIwggEiMA0GCSqGSIb3DQEBAQUAA4IB\n' +
		'DwAwggEKAoIBAQDHDmw/I5N/zHClnSDDDlM/fsBOwphJykfVI+8DNIV0yKMCLkZc\n' +
		'C33JiJ1Pi/D4nGyMVTXbv/Kz6vvjVudKRtkTIso21ZvBqOOWQ5PyDLzm+ebomchj\n' +
		'SHh/VzZpGhkdWtHUfcKc1H/hgBKueuqI6lfYygoKOhJJomIZeg0k9zfrtHOSewUj\n' +
		'mxK1zusp36QUArkBpdSmnENkiN74fv7j9R7l/tyjqORmMdlMJekYuYlZCa7pnRxt\n' +
		'Nw9KHjUgKOKv1CGLAcRFrW4rY6uSa2EKTSDtc7p8zv4WtdufgPDWi2zZCHlKT3hl\n' +
		'2pK8vjX5s8T5J4BO/5ZS5gIg4Qdz6V0rvbLxAgMBAAGjggElMIIBITAOBgNVHQ8B\n' +
		'Af8EBAMCAQYwEgYDVR0TAQH/BAgwBgEB/wIBADAdBgNVHQ4EFgQUlt5h8b0cFilT\n' +
		'HMDMfTuDAEDmGnwwRwYDVR0gBEAwPjA8BgRVHSAAMDQwMgYIKwYBBQUHAgEWJmh0\n' +
		'dHBzOi8vd3d3Lmdsb2JhbHNpZ24uY29tL3JlcG9zaXRvcnkvMDMGA1UdHwQsMCow\n' +
		'KKAmoCSGImh0dHA6Ly9jcmwuZ2xvYmFsc2lnbi5uZXQvcm9vdC5jcmwwPQYIKwYB\n' +
		'BQUHAQEEMTAvMC0GCCsGAQUFBzABhiFodHRwOi8vb2NzcC5nbG9iYWxzaWduLmNv\n' +
		'bS9yb290cjEwHwYDVR0jBBgwFoAUYHtmGkUNl8qJUC99BM00qP/8/UswDQYJKoZI\n' +
		'hvcNAQELBQADggEBAEYq7l69rgFgNzERhnF0tkZJyBAW/i9iIxerH4f4gu3K3w4s\n' +
		'32R1juUYcqeMOovJrKV3UPfvnqTgoI8UV6MqX+x+bRDmuo2wCId2Dkyy2VG7EQLy\n' +
		'XN0cvfNVlg/UBsD84iOKJHDTu/B5GqdhcIOKrwbFINihY9Bsrk8y1658GEV1BSl3\n' +
		'30JAZGSGvip2CTFvHST0mdCF/vIhCPnG9vHQWe3WVjwIKANnuvD58ZAWR65n5ryA\n' +
		'SOlCdjSXVWkkDoPWoC209fN5ikkodBpBocLTJIg1MGCUF7ThBCIxPTsvFwayuJ2G\n' +
		'K1pp74P1S8SqtCr4fKGxhZSM9AyHDPSsQPhZSZg=\n' +
		'-----END CERTIFICATE-----'
	)
}



// WEBPACK FOOTER //
// ./src/common/qz/cert.js